import { render } from "./BaseGreenButton.vue?vue&type=template&id=4be2a2d5"
import script from "./BaseGreenButton.vue?vue&type=script&lang=js"
export * from "./BaseGreenButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__